//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SingleWebCoin from '~/components/detail/desktop/single_web_coin'

export default {
  name: 'CoinsTable',
  components: { SingleWebCoin },
  props: {
    wantedCoinsList: {
      type: Array,
      default: null
    },
    currencyType: {
      type: String,
      default: null
    }
  }
}
